export const dateFormatEnum = {
  utc: "utc",
  local: "local",
};
